export let constants = {
  host: "https://lipayments.adityabirlacapital.com",
  host_admin: "https://liadmin.adityabirlasunlifeinsurance.com",
  // host: "http://localhost:4002",
  host_redirect: "http://localhost:3002/"
};